(() => {
  const ProductLifestyleCarousel = () => {
    let InitCarousel = () => {
      document.querySelectorAll('.product-lifestyle-carousel .carousel:not(.flickity-enabled)').forEach(($carousel) => {
        var flkty = new Flickity($carousel, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          watchCSS: true,
          pageDots: false,
          //adaptiveHeight: true,
          on: {
            ready() {
            }
          }
        });
  
        let breakpoint = window.matchMedia('(max-width: 768px)');
        breakpoint.addEventListener('change', (e) => {
          setTimeout(() => {
            flkty.resize();
          }, 100);
        });
      });  

      // if already initialized, just refresh
      document.querySelectorAll('.product-lifestyle-carousel .carousel.flickity-enabled').forEach(($carousel) => {
        let flkty = Flickity.data($carousel);
        flkty.resize();
      });
    }

    InitCarousel();

    ['shopify:block:deselect','shopify:section:unload'].forEach((e_type) => {
      document.addEventListener(e_type, (e) => {
        setTimeout(InitCarousel, 100);
      });
    });
  }

  const DOMReady = () => {
    ProductLifestyleCarousel();    
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();